<template>
  <div class="vpassword_input">
    <input
      type="password"
      :name="cname"
      v-model="inner"
      style="opacity: 0; height: 0; width: 0; padding:0; margin: 0; border: 0;"
    />
    <input
      class="pinput"
      :placeholder="placeholder"
      :class="{ vp_error: error }"
      :type="type"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
    <div v-if="hidden" @click="set_hidden(false)" class="vpass_eye">
      <eye-off :color="'grey'" :hover="'black'"></eye-off>
    </div>
    <div v-else @click="set_hidden(true)" class="vpass_eye">
      <eye-on :color="'grey'" :hover="'black'"></eye-on>
    </div>
  </div>
</template>

<script>
  /*
  @ complex component
  @ props: value(any), error(bool), name(any), opne(bool)
  @ emit: input
*/
  export default {
    name: 'vpassword_input',
    props: ['value', 'error', 'name', 'open', 'placeholder'], // open - защита от сохранение браузером введеного значения
    data() {
      return {
        hidden: true,
        inner: ''
      };
    },
    computed: {
      type() {
        return this.hidden ? 'password' : 'text';
      },
      cname() {
        if (this.open === true) {
          return this.name;
        }
        return this.name + Math.random();
      }
    },
    methods: {
      set_hidden(v) {
        this.hidden = v;
      }
    },
    watch: {
      value() {
        this.inner = this.value;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../assets/styles/vars.scss';
  .vpassword_input {
    display: flex;
    align-items: center;
    position: relative;
    max-width: 380px;
    .pinput {
      width: 100%;
      padding-right: 46px;
      color: #333;

      &.vp_error {
        border-color: $color-error;
      }
    }
    .vpass_eye {
      cursor: pointer;
      position: absolute;
      right: 13px;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
